import { useState, useEffect } from "react";
import AppStrings from "../api/AppStrings";

export default function useParams() {
  const [params, setParams] = useState({
    customer_id: null,
    api_key: null,
    teacher_id: null,
    is_logged_in: null,
    user_id: null,
  });

  useEffect(() => {
    const customer_id = JSON.parse(localStorage.getItem("CUSTOMER_ID"));
    const api_key = JSON.parse(localStorage.getItem("API_KEY"));
    const teacher_id = JSON.parse(localStorage.getItem("TEACHER_ID"));
    const is_logged_in = JSON.parse(localStorage.getItem("is_logged_in"));
    const user_id = JSON.parse(localStorage.getItem('user_id'));

    setParams({
      customer_id,
      api_key,
      teacher_id,
      is_logged_in,
      user_id,
    });
  }, []); // runs only once on mount

  return [params, setParams];
}
